import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";

const NAV_LINKS = [
  { href: "#services", label: "Services" },
  { href: "#why", label: "Why Choose Us" },
  { href: "#about", label: "About" },
  { href: "#faq", label: "FAQ" },
  { href: "#service-area", label: "Service Area" },
  { href: "#contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 transition-colors duration-200 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-neutral-200"
          : "bg-white/70 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <div className="container-mv flex h-16 md:h-20 items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-neutral-700 hover:text-brand-red transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:4034043515"
            data-testid="nav-call-btn"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-semibold text-brand-black hover:text-brand-red transition-colors"
          >
            <Phone className="w-4 h-4" /> 403-404-3515
          </a>
          <a
            href="#contact"
            data-testid="nav-book-btn"
            className="inline-flex items-center rounded-full bg-brand-red text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#CC0000] active:scale-95 transition-all shadow-sm"
          >
            Book Service
          </a>
          <button
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-neutral-100"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-neutral-200 bg-white" data-testid="nav-mobile-menu">
          <div className="container-mv py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-2 py-3 text-sm font-medium text-neutral-800 hover:bg-neutral-50 rounded-md"
              >
                {l.label}
              </a>
            ))}
            <a href="tel:4034043515" className="px-2 py-3 text-sm font-semibold text-brand-red">
              Call 403-404-3515
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
